import { api } from "../../api/apiSlice";

export const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: ({ username, password }) => ({
        url: "/auth/login",
        method: "POST",
        data: { username, password },
      }),
      invalidatesTags: ["Dashboard"],
    }),
  }),
  overrideExisting: false,
});

export const { useLoginMutation } = authApi;
